"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDots = exports.Wrapper = exports.Dot = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
/**
 * The dots will inherit the color assigned via the `color` css property from it's parent, but will not pick up the
 * color if the value is assigned to itself
 */
exports.Dot = styled_components_1.default.div.withConfig({ displayName: "reports-Dot", componentId: "reports-fms6ud" }) `
  margin: 0.25em 0.3em;
  border-radius: 50%;
  height: 0.5em;
  width: 0.5em;
  background-color: ${({ theme, status }) => (theme && status ? theme[status] : 'currentColor')};
`;
const fadeIn = (0, styled_components_1.keyframes) `
  from { opacity: 1; }
  to { opacity: 0; }
`;
const Dot1 = (0, styled_components_1.default)(exports.Dot).withConfig({ displayName: "reports-Dot1", componentId: "reports-vx5aei" }) `
  animation: ${fadeIn} 1.5s ease infinite;
`;
const Dot2 = (0, styled_components_1.default)(exports.Dot).withConfig({ displayName: "reports-Dot2", componentId: "reports-1sufgim" }) `
  animation: ${fadeIn} 1.5s ease 0.15s infinite;
`;
const Dot3 = (0, styled_components_1.default)(exports.Dot).withConfig({ displayName: "reports-Dot3", componentId: "reports-762khs" }) `
  animation: ${fadeIn} 1.5s ease 0.3s infinite;
`;
exports.Wrapper = styled_components_1.default.div.withConfig({ displayName: "reports-Wrapper", componentId: "reports-1f9bbvy" }) `
  display: flex;

  & > * {
    background-color: currentcolor;
  }
`;
/**
 * The dots will inherit the color assigned via the `color` css property from it's parent, but will not pick up the
 * color if the value is assigned to itself
 */
const LoadingDots = () => (React.createElement(exports.Wrapper, null,
    React.createElement(Dot1, null),
    React.createElement(Dot2, null),
    React.createElement(Dot3, null)));
exports.LoadingDots = LoadingDots;
exports.default = (0, styled_components_1.default)(exports.LoadingDots).withConfig({ componentId: "reports-6eed2w" }) ``;
//# sourceMappingURL=index.js.map